import React from "react";

export default () => <div>Fields (@TODO: Migrate fields page)</div>;
